module.exports = __webpack_public_path__ + "static/media/CSBannerProperties1.74c63d2d.svg";